<template>
    <div>
        <div v-show="chips" style="padding-top: 15px">
            赠送当前页，需要金豆合计：{{chips}}
            <el-button type="primary" size="small" @click="removeList">一键赠送</el-button>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" height="100%" :data="waitingRecordLog.beanList" row-key="id">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="玩家昵称" align="center" prop="userName"/>
                <el-table-column label="玩家ID" align="center" prop="userRandomId"/>
                <el-table-column label="赠送金豆数量" align="center" prop="sendChips">
                <template slot-scope="scope">
                  {{scope.row.sendChips/100}}
                </template>
                </el-table-column>
                <el-table-column label="赠送原因" align="center" prop="sendDesc"/>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="removeItem([scope.row.id])">赠送</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="waitingRecordLog.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('market', ['waitingRecordLog', 'marketAccount']),
            chips() {
                let value = 0;
                this.waitingRecordLog.beanList.forEach(item => {
                    value += item.sendChips
                });
                return value
            }
        },
        methods: {
            ...mapActions('market', ['getWaitingRecordLogList', 'deleteWaitingRecordLog']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getWaitingRecordLogList(page).then(() => {
                    this.loading = false;
                    if (this.currentPage !== 1 && !this.waitingRecordLog.beanList.length) {
                        this.getList(this.currentPage - 1)
                    }
                })
            },
            removeList() {
                let ids = this.waitingRecordLog.beanList.map(item => {
                    return item.id
                });
                this.removeItem(ids)
            },
            removeItem(ids) {
                this.deleteWaitingRecordLog(ids).then(() => {
                    this.$message.success('赠送成功');
                    this.getList(this.currentPage);
                })
            }
        }
    }
</script>
